/**
 * Returns a new array sorted by date descending.
 * @param {Array} list - List of objects with a date field
 * @param {string} dateField - Property name for the date (default: "date")
 */
export function sortByDateDesc(list, dateField = "date") {
  return [...(list || [])].sort((a, b) => {
    const da = a[dateField] ? new Date(a[dateField]) : new Date(0);
    const db = b[dateField] ? new Date(b[dateField]) : new Date(0);
    return db - da;
  });
}
